import React, { useState } from "react"
import { Navigate } from "react-router-dom"
import getAppConfig from "~/utils/getAppConfig"
import { useToast } from "~/utils/Toast"

import { apiCategories } from "~/routes"

import PageContainer from "~/library/PageContainer"
import CategoryForm from "~/components/CategoryForm"

const NewCategory = () => {
  const { venueSlug } = getAppConfig()
  const [createdCategoryId, setCreatedCategoryId] = useState<string | null>(null)
  const toast = useToast()

  const handleSubmit = (formValues: any) => {
    const data = {
      venue_slug: venueSlug,
      category: formValues,
    }

    const req = apiCategories.create({ data })

    req
      .then(({ category }) => {
        setCreatedCategoryId(category.id)
        toast("Category created successfully", "success")
      })
      .catch((res) => {
        toast(
          `Error creating category. ${res.body?.errors?.join(", ") || "Please try again"}`,
          "danger"
        )
      })
  }

  if (createdCategoryId) {
    return <Navigate to={`/categories/${createdCategoryId}`} />
  }

  return (
    <PageContainer>
      <div className="row h-100">
        <div className="col-6 offset-3 align-center mt-4">
          <h3 className="mb-3">New Category</h3>
          <CategoryForm onSubmit={handleSubmit} />
        </div>
      </div>
    </PageContainer>
  )
}

export default NewCategory
